import { Col } from "react-bootstrap"
import ContentLoader from "react-content-loader"

interface ISkillLoader {
  count?: number
}

const SkillLoader = ({ count = 0 }: ISkillLoader) => {

  if (count > 0) {
    return (<>{[...Array(count)].map((e, i) => {
      return <Col lg={4} xs={12} key={i} className="bg-white rounded-lg">
        <ContentLoader
          speed={2}
          width={"100%"}
          height={"100%"}
          viewBox="0 0 300 250"
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb">
          <circle cx="98" cy="94" r="82" />
          <rect x="49" y="193" rx="6" ry="6" width="94" height="18" />
        </ContentLoader>
      </Col>
    })}</>)
  }
  return <Col className="bg-white rounded-lg">
    <ContentLoader
      speed={2}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb">
      <circle cx="62" cy="38" r="27" />
      <rect x="17" y="72" rx="5" ry="5" width="90" height="11" />
    </ContentLoader>
  </Col>
}

export default SkillLoader
